import { useContext } from 'react';
import { AppContext } from '../../context';
import { Brand } from '../../lib/localisation';
import { Colors } from '../../lib/util';
import MobilePayLogo from '../MobilePayLogo/MobilePayLogo';
import VippsLogo from '../VippsLogo/VippsLogo';
import './PoweredByVipps.css';

export default function PoweredByVipps(): JSX.Element {
  const context = useContext(AppContext);
  const BrandLogo = context.currentTheme === Brand.Vipps ? VippsLogo : MobilePayLogo;

  return (
    <div className="powered-by-vipps">
      {context.texts.poweredBy}
      <BrandLogo color={Colors.Grey} />
    </div>
  );
}
